import { colors } from '../variables';

export default {
  MuiTabs: {
    styleOverrides: {
      root: ({ theme }: any) => ({
        '.MuiTab-root': {
          textTransform: 'capitalize',
          '&.MuiTab-textColorPrimary': {
            color: theme.palette.text.secondary,
          },
        },

        '.MuiButtonBase-root': {
          padding: 0,
        },
        '.MuiTabs-indicator': {
          backgroundColor: colors.error.main,
        },
      }),
    },
  },
};
